// extracted by mini-css-extract-plugin
export default {"header":"SelectAllHandler_header__6z5bV"};